import * as React from "react";
import * as Icons from "./Icons";

interface UploadButtonProps {
  onBegin: () => void;
  onComplete: () => void;
  onProgress: (percentage: number) => void;
  visitorId: string;
  engagementId: string;
  engagementApiEndpoint: string;
  maxFileSizeBytes: number;
  fileSizeErrorMessage: string;
  siteId: number;
}

class UploadButton extends React.Component<UploadButtonProps, {}> {
  fileInput: HTMLInputElement;

  onChange = (e: React.FormEvent<HTMLInputElement>) => {
    const file = e.currentTarget.files[0];

    if (file.size > this.props.maxFileSizeBytes) {
      alert(this.props.fileSizeErrorMessage);
      e.currentTarget.value = "";
      return;
    }

    const formData = new FormData();
    const url = `${this.props.engagementApiEndpoint}/v1/${
      this.props.siteId
    }/Engagement/UploadFile`;
    const xhr = new XMLHttpRequest();

    formData.append("engagementId", this.props.engagementId);
    formData.append("visitorId", this.props.visitorId);
    formData.append("file", file);

    xhr.open("POST", url, true);

    xhr.addEventListener("progress", e => {
      this.props.onProgress(Math.ceil(e.loaded / e.total) * 100);
    });

    xhr.addEventListener("load", e => {
      this.props.onComplete();

      if (xhr.status === 200) {
        return;
      }

      if (xhr.status === 500) {
        alert("unknown error");
        return;
      }

      if (xhr.status === 400) {
        const errorData = JSON.parse(xhr.responseText);
        alert(errorData.Message);
        return;
      }
    });

    this.props.onBegin();
    xhr.send(formData);
    e.currentTarget.value = "";
  };

  render() {
    return (
      <React.Fragment>
        <input
          type="file"
          style={{ display: "none" }}
          ref={fileInput => {
            this.fileInput = fileInput;
          }}
          onChange={this.onChange}
        />
        <button
          className="velaro-bg-light-gray"
          onClick={() => this.fileInput.click()}
          role="button"
          aria-label="Upload File"
        >
          <Icons.AttachmentIcon />
        </button>
      </React.Fragment>
    );
  }
}

export default UploadButton;
